import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { StoryState } from './state/story.state';
import { StoryLabelsState } from './state/labels/story.labels.state';
import { LabelsComponent } from './components/labels/labels/labels.component';
import { SharedModule } from '../shared/shared.module';
import { StoryChaptersState } from './state/chapters/story.chapters.state';
import { MaterialModule } from '../material.module';
import { ContextLabelComponent } from './components/labels/context-label/context-label.component';
import { NodeActionsModule } from '../shared/components/node-actions/node-actions.module';
import { MarkdownModule } from 'ngx-markdown';
import { LabelPinComponent } from './components/labels/label-pin/label-pin.component';
import { ContentBlocksModule } from '../content-blocks/content-blocks.module';
import { GenericLabelComponent } from './components/labels/generic-label/generic-label.component';
import { QuizLabelComponent } from './components/labels/quiz-label/quiz-label.component';
import { StoryLabelComponent } from './components/labels/story-label/story-label.component';
import { ReactiveFormsModule } from '@angular/forms';
import { QuizModule } from '../quiz/quiz.module';
import { QuizLabelsComponent } from './components/labels/quiz-labels/quiz-labels.component';

@NgModule({
  imports: [
    NgxsModule.forFeature([StoryState, StoryChaptersState, StoryLabelsState]),
    CommonModule,
    SharedModule,
    MaterialModule,
    NodeActionsModule,
    ContentBlocksModule,
    ReactiveFormsModule,
    MarkdownModule.forChild(),
    QuizModule
  ],
  declarations: [
    LabelsComponent,
    ContextLabelComponent,
    LabelPinComponent,
    GenericLabelComponent,
    QuizLabelComponent,
    StoryLabelComponent,
    QuizLabelsComponent
  ],
  exports: [
    LabelsComponent,
    LabelPinComponent,
    GenericLabelComponent,
    QuizLabelComponent,
    StoryLabelComponent
  ],
})
export class StoryModule {}
